<template>
  <div>
    <div v-if="guide">
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <profile :user="guide.user" />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <card-plan
              v-for="(aPlan, index) in guide.profile.plans"
              :plan="aPlan"
              :user-profile="profile"
              :guide="guide"
              :key="index"
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-if="processed && !guide">
      Guide does not exist
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import Profile from "./profile";
import CardPlan from "./cardPlan";

export default {
  components: {
    Profile,
    CardPlan
  },
  created() {
    if (this.$route.params.guideProfileName) {
      this.$nprogress.start();
      this.$store
        .dispatch(
          "listings/getGuideByProfileName",
          this.$route.params.guideProfileName
        )
        .then(data => {
          // debugger;
          if (data) {
            // debugger;
            this.guide = data;
            this.processed = true;
          }

          this.$nprogress.done();
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    }
  },
  computed: {
    ...mapGetters({
      profile: "user/profile"
    }),
    getDate() {
      return moment(this.successBook.date).format("dddd, MMMM DD");
    },
    getTime() {
      return moment(`${this.successBook.date} ${this.successBook.time}`).format(
        "hh:mm A"
      );
    }
  },
  methods: {},
  data() {
    return {
      processed: false,
      guide: null,
      date: "",
      time: "",
      successBook: null
    };
  }
};
</script>
